import React, {PureComponent} from 'react';
import TextImageRow from '../components/text-image-row';
import { SectionChild } from '../components/section';

export default class extends PureComponent<Props, void> {
  static _type = 'TextImageRow';
  _type = 'TextImageRow';

  render() {
    const {
      label,
      sublabel,
      icon,
      iconColor,
      rounded,
      iconRight
    } = this.props;

    return (
      <SectionChild>
        <TextImageRow
          label={label}
          sublabel={sublabel}
          icon={icon}
          iconColor={iconColor}
          rounded={rounded}
          iconRight={iconRight}
        />
      </SectionChild>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/text-image-row.js